import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { BTabs, BTab, BButton, BModal } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions, mapGetters } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'
import { fetchCustomer } from '@kwixeo/customers-vue'
import ProductList from '../ProductList/ProductList.vue'
import ServiceList from '../ServiceList/ServiceList.vue'

@Component({
  methods: {
    ...mapActions('dynamicModals', ['openModal'])
  },
  computed: {
    ...mapGetters('user', ['can']),
    ...mapGetters('subscriptions', ['hasModule'])
  },
  components: {
    ProductList,
    ServiceList,
    FontAwesomeIcon,
    BTabs, BTab, BButton, BModal
  }
})
export default class CatalogList extends Vue {
  openModal!: (params: string|KwixeoInterface.OpenModalParamObject) => void
  hasModule!: (key: string) => boolean
  can!: (key: string, level: number) => boolean

  @Prop({ default: null }) only!: string|string[]|null
  @Prop({ default: null }) filters!: null|KwixeoInterface.GenericObject
  @Prop({ default: null }) include!: { [key: string]: string[] }|null

  private askForAdding = false
  private askType: string|null = null
  private askElement: KwixeoCatalog.CatalogElement|null = null

  private async newProduct (): Promise<void> {
    const value: Partial<KwixeoCatalog.FormProduct> = {}
    if (this.filters) {
      if (this.filters.with_stock) {
        value.with_stock = true
      }
      if (this.filters?.providers && !Array.isArray(this.filters.providers)) {
        const provider = await fetchCustomer(this.filters.providers)
        value.providers = [provider]
        value.providers_references = [
            {
              customer: provider,
              reference: '',
              buy_price_ht: 0,
              various_costs: 0,
              total_costs: 0
            }
        ]
      }
    }
    this.openModal({ key: 'catalog-product-form', value })
  }

  mounted (): void {
    emitter.on('productCreated', this.productCreated)
    emitter.on('productUpdated', this.productUpdated)
    emitter.on('serviceCreated', this.serviceCreated)
    emitter.on('serviceUpdated', this.serviceUpdated)
    emitter.on('groupCreated', this.groupCreated)
    emitter.on('groupUpdated', this.groupUpdated)
  }

  destroyed (): void {
    emitter.off('productCreated', this.productCreated)
    emitter.off('productUpdated', this.productUpdated)
    emitter.off('serviceCreated', this.serviceCreated)
    emitter.off('serviceUpdated', this.serviceUpdated)
    emitter.off('groupCreated', this.groupCreated)
    emitter.off('groupUpdated', this.groupUpdated)
  }

  private addProduct (product: KwixeoCatalog.Product): void {
    this.addElement('product', product)
  }

  private addService (service: KwixeoCatalog.Service): void {
    this.addElement('service', service)
  }

  private addGroup (group: KwixeoCatalog.Group): void {
    this.addElement('group', group)
  }

  @Emit('selected')
  private addElement (type: string, element: KwixeoCatalog.CatalogElement): { type: string; data: KwixeoCatalog.CatalogElement } {
    return {
      type,
      data: element
    }
  }

  private async newElement (type: string): Promise<void> {
    let value

    if (type === 'product' && this.filters?.providers && !Array.isArray(this.filters.providers)) {
      const provider = await fetchCustomer(this.filters.providers)
      value = {
        providers: [provider],
        providers_references: [
          {
            customer: provider,
            reference: null,
            buy_price_ht: 0,
            various_costs: 0,
            total_costs: 0
          }
        ]
      }
    }

    this.openModal({
      key: 'catalog-' + type + '-form',
      value
    })
  }

  private productCreated (product: KwixeoCatalog.Product): void {
    this.askForAddElement('product', product)
  }

  private productUpdated (event: KwixeoCatalog.ProductUpdateEvent): void {
    this.askForAddElement('product', event.new)
  }

  private serviceCreated (service: KwixeoCatalog.Service): void {
    this.askForAddElement('service', service)
  }

  private serviceUpdated (event: KwixeoCatalog.ServiceUpdateEvent): void {
    this.askForAddElement('service', event.new)
  }

  private groupCreated (group: KwixeoCatalog.Group): void {
    this.askForAddElement('group', group)
  }

  private groupUpdated (event: KwixeoCatalog.GroupUpdateEvent): void {
    this.askForAddElement('group', event.new)
  }

  private askForAddElement (type: string, element: KwixeoCatalog.CatalogElement): void {
    this.askType = type
    this.askElement = element
    this.askForAdding = true
  }

  private notHide (type: string): boolean {
    if (this.only === null) {
      return true
    } else if (typeof this.only === 'string') {
      return this.only === type
    } else {
      return this.only.includes(type)
    }
  }
}
